// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__16_M9","col":"styles_col__2KILV"};